module.exports = __webpack_public_path__ + "img/腳色介面_02-拍攝頭像頁.74d91b44.png";